export const ChatSmileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="#F5F5F5" d="M0 0H24V24H0z"></path>
      <g>
        <path fill="#1F2937" d="M0 0H1440V50H0z" transform="translate(-1133 -13)"></path>
        <g>
          <g>
            <g>
              <path
                fill="currentColor"
                d="M6.455 19L2 22.5V5c0-1 1-2 2-2h16c1 0 2 1 2 2v12c0 1-1 2-2 2H6.455zm-.692-2H20V5H4v13.385L5.763 17zM7 10h2a3 3 0 106 0h2a5 5 0 01-10 0z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
